import { preventIEError, throttle } from '@neux/ui-jquery/tool';
import mobileMenu from './mobileMenu.js';
import scrollUpShowHeader from './scrollUpShowHeader.js';
import { convertPageInfo, getData } from './util';
require('paginationjs');

function initializePage(pageInfo) {
	pageInfo = pageInfo || { page_size: $(window).outerWidth() > 919 ? 10 : 5 };

	getData(
		'news',
		'GET',
		paginationFn,
		pageInfo
	);

}

function windowResizeFn() {

	let $newList = $('#news__list');
	let windowSizeWidth = $(window).outerWidth();
	if (
		!$newList.hasClass('changing') &&
		(
			windowSizeWidth > 919 && !$newList.hasClass('page__size--10') ||
			windowSizeWidth <= 919 && !$newList.hasClass('page__size--5')
		)
	) {

		let $pagination = $('#pagination-container');
		let pageNum = $pagination && $pagination.pagination('getCurrentPageNum') || 1;
		let pageSize = sessionStorage.getItem('pageSize') || 10;
		$newList.removeClass('page__size--10 page__size--5').addClass('changing');
		initializePage(convertPageInfo(
			{
				page: pageNum,
				page_size: pageSize
			},
			windowSizeWidth > 919 ? 10 : 5
		));
	}
}

function main() {
	// init
	preventIEError();
	initializePage();
	throttle(
		$(window).on('resize', function () {
			windowResizeFn();
		})
	);
	// for api
	scrollUpShowHeader();
	mobileMenu();

}

function itemTemplate(data) {
	let outputText = '';

	$.each(data, function (index, item) {
		let url = item.url.url ? item.url.url.indexOf('http') !== 0 ? `news_detail.html?id=${item.id}` : item.url.url : 'javascript:;';
		outputText += `
    <li class="news__item">
      <div class="news__date">${item.start_date}</div>
      ${item.base_info?.type_name != '' ? `<div class="news__category">${item.base_info?.type_name}</div>` : ''}
      ${item.is_new ? '<div class="news__tag">New</div>' : ''}
      <a
        class="news__link"
        href="${url}"
        ${item.url.url_blank ? 'target="_blank"' : ''}
        title="${item.title}${item.url.url_blank ? ' (另開視窗)' : ''}">
          ${item.title}${item.url.url_blank ? ' (另開視窗)' : ''}
      </a>
    </li>
    `;
	});

	return outputText;
}

function renderData(data) {
	let listHTML = itemTemplate(data.datas);
	$('#news__list').html(listHTML);
}

function scrollDataTop() {
	let newsContainerTop = $('.news__container').parent().offset().top;
	let headerHeight = $(window).width() > 1159 ? 0 : $('.header__top').outerHeight();
	let scrollToValue = newsContainerTop - headerHeight;
	$('html, body').stop().animate({
		scrollTop: scrollToValue
	}, 300, 'linear');
}

function createTotalArray(total) {
	let arr = [];
	let i = 0;
	while (i < total) {
		arr.push(i);
		i++
	}
	return arr;
}

function paginationFn(jsonData) {
	// 給予news__list當前的page__size數量來判斷resize是否要執行重設
	// changing來擋住重複執行
	$('#news__list').removeClass('changing').addClass($(window).width() > 919 ? 'page__size--10' : 'page__size--5');
	let $pagination = $('#pagination-container');
	let pageSize = jsonData.page_info.page_size;
	let paginationConfig = {
		dataSource: createTotalArray(jsonData.page_info.total_rec_size),
		pageNumber: jsonData.page_info.page,
		pageLink: 'javascript:;',
		pageRange: $(window).width() > 919 ? 2 : 1,
		pageSize: pageSize,
		ulClassName: 'paginationjs__list',
		ellipsisText: '<span class="paginationjs__dot"></span>',
		prevText: '上一頁<svg><use xlink:href="#icon_chevron-left" /></svg>',
		nextText: '下一頁<svg><use xlink:href="#icon_chevron-right" /></svg>',
		beforeInit: function () {
			// 渲染資料
			renderData(jsonData);
		},
		afterPageOnClick: function (e, pageNumber) {
			getData('news', 'GET', renderData, { page: pageNumber, page_size: pageSize });
			scrollDataTop();
		},
		afterPreviousOnClick: function (e, pageNumber) {
			getData('news', 'GET', renderData, { page: pageNumber, page_size: pageSize });
			scrollDataTop();
		},
		afterNextOnClick: function (e, pageNumber) {
			getData('news', 'GET', renderData, { page: pageNumber, page_size: pageSize });
			scrollDataTop();
		},
	}
	$pagination.pagination(paginationConfig);

	// 加入data-size方便resize取用
	sessionStorage.setItem('pageSize', pageSize);
}

main();